<section class="max-w-[1160px] mx-auto">
  @defer(on viewport) {
  <header>
    <h2 class="h3-responsive font-bold text-center">Didn't enough? Contact us.</h2>
  </header>
  <section class="office flex flex-col gap-24 md:gap-0 md:flex-row items-center justify-between my-24">
    @for (itm of officeInfos; track $index) {
    <icon-title-desc>
      <a image [attr.href]="itm.link" class="curser-pointer">
        <img [ngSrc]="itm.imageLink" alt="" width="75" height="75" />
      </a>
      <div title>
        <a class="curser-pointer font-bold h6-responsive text-primary" [attr.href]="itm.link">
          {{ itm.title }}
        </a>
      </div>
      <p description class="h6-responsive font-thin text-gray-500">
        {{ itm.description }}
      </p>
    </icon-title-desc>
    }
  </section>
  }@placeholder {
  <div class="spinner-center">
    <mat-spinner></mat-spinner>
  </div>
  }
</section>
